module.exports = __webpack_public_path__ + "media/audios/kid/lesson_7/audio40-7e05fc34c6e207250a339b01d7f2bed8.m4a";